import { Typography } from "@mui/material";
import useScreenSize from "../hooks/useScreenSize";

function NoDataFound() {
  //   return (
  //     <>
  //       <figure style={{ textAlign: "center" }}>
  //         <img
  //           src="https://i.pinimg.com/originals/0e/f3/b8/0ef3b8c222b707583b00f67a147d7a2e.gif"
  //           alt="No Data Found"
  //           height="200px"
  //           width="200px"
  //         />
  //         <figcaption className="text-center" style={{ fontWeight: "500" }}>
  //           No Data Found
  //         </figcaption>
  //       </figure>
  //     </>
  //   );

  const size = useScreenSize();
  return (
    <div
      style={{
        width: "100%",
        height: size.height / 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        alignContent: "center",
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          color: "gray",
          fontWeight: 300,
          fontStyle: "italic",
          fontSize: 12,
        }}
      >
        No data found.
      </Typography>
    </div>
  );
}

export default NoDataFound;
